<template>
  <main class="main" role="main">
    <div class="main_con booking_form">
      <div class="booking_title">{{ selectTelecomName }} 사전예약</div>
      <div class="form_wrap">
        <div class="form">
          <ul class="form_ul">
            <li class="form_li">
              <div class="form_in">
                <div class="select" :class="{ on: selectedTypeOn }">
                  <button @click="showTypeModal">
                    {{ selectedTypeText }}<span class="i_drop"></span>
                  </button>
                </div>
                <!--'on 추가'-->

                <div class="select" :class="{ on: selectedItemOn }">
                  <button @click="showItemModal">
                    {{ selectedItemText }}<span class="i_drop"></span>
                  </button>
                </div>
                <!--'on 추가'-->
                <div class="select" :class="{ on: selectedColorOn }">
                  <button @click="showColorModal">
                    {{ selectedColorText }}<span class="i_drop"></span>
                  </button>
                </div>
                <label class="input"
                  ><input
                    type="text"
                    maxlength="8"
                    ref="selectedName"
                    @keyup="selectNameValueChk"
                    :placeholder="selectedNameText"
                    v-model="selectCustomerName"
                  />
                </label>
                <label class="input num_input"
                  ><input
                    type="number"
                    maxlength="6"
                    ref="selectedBirth"
                    @keyup="selectBirthValueChk"
                    :placeholder="selectedBirthText"
                    v-model="selectResidentNumber"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  />
                </label>
                <label class="input num_input"
                  ><input
                    type="number"
                    maxlength="11"
                    ref="selectedPhone"
                    @keyup="selectPhoneValueChk"
                    :placeholder="selectedPhoneNumText"
                    v-model="selectCustomerMobile"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  />
                </label>
                <!--'on 추가'-->
                <div class="select" :class="{ on: selectedTelecomOn }">
                  <button @click="showTelecomModal">
                    {{ selectedTelecomText }}<span class="i_drop"></span>
                  </button>
                </div>
                <!--'on 추가'-->
                <p class="valid" :class="{ on: !isValid }">
                  <i class="i_valid"></i>{{ errorMessage }}
                </p>
                <!--'on 추가'-->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="btm_btn">
      <div class="btn_wrap" v-if="isMode == 'CREATE'">
        <button
          @click="saveEstimationAuto"
          class="btn"
          :disabled="
            !(
              selectedTypeOn === true &&
              selectedItemOn === true &&
              selectedColorOn === true &&
              selectedNameOn === true &&
              selectedBirthOn === true &&
              selectedPhoneNumOn === true &&
              selectedTelecomOn === true
            )
          "
        >
          저장하기
        </button>
      </div>
      <div class="btn_wrap" v-else-if="isMode == 'MODIFY'">
        <button
          @click="modifyEstimationAuto"
          class="btn"
          :disabled="
            !(
              selectedTypeOn === true &&
              selectedItemOn === true &&
              selectedColorOn === true &&
              selectedNameOn === true &&
              selectedBirthOn === true &&
              selectedPhoneNumOn === true &&
              selectedTelecomOn === true
            )
          "
        >
          수정하기
        </button>
      </div>
    </div>

    <TypeModal
      ref="typeModal"
      @select="selectType"
      @close="closeTypeModal"
    ></TypeModal>
    <ItemModal
      ref="itemModal"
      @select="selectItem"
      @close="closeItemModal"
    ></ItemModal>
    <ColorModal
      ref="colorModal"
      @select="selectColor"
      @close="closeColorModal"
      :deviceColor="deviceColor"
    ></ColorModal>
    <TelecomModal
      ref="telecomModal"
      @select="selectTelecom"
      @close="closeTelecomModal"
    ></TelecomModal>
  </main>
</template>

<script>
import TypeModal from '@/front/customer/views/booking/components/TypeModal';
import ItemModal from '@/front/customer/views/booking/components/ItemModal';
import ColorModal from '@/front/customer/views/booking/components/ColorModal';
import TelecomModal from '@/front/customer/views/booking/components/TelecomModal';

import {
  mapActions as bookingMapActions,
  mapGetters as bookingMapGetters,
} from '@common/store/modules/booking';
import * as bookingTypes from '@common/store/modules/booking/types';

export default {
  name: 'BookingForm',
  components: { TypeModal, ItemModal, ColorModal, TelecomModal },
  computed: {
    // ...estimateMapGetters({
    //   estimationModel: estimateTypes.ESTIMATION_MODEL,
    // }),
  },
  mounted() {
    this.selectTelecomName = this.$route.query.telecomName;
    this.isMode = this.$route.query.mode;
    this.uuid = this.$route.query.uuid;

    console.log(this.isMode); // CREATE, MODIFY
    console.log(this.id);

    if (this.isMode == 'MODIFY') {
      this.id = this.$route.query.id;
      this.getBookingInfo(this.id);
    }
  },
  created() {},
  data() {
    return {
      selectTelecomName: 'SKT',
      isMode: 'CREATE',
      id: '',
      uuid: '',

      selectTelecomList: ['SKT', 'KT', 'LGU+'],
      selectTelecomId: ['SKT', 'KT', 'LG'],

      typeList: ['신규가입', '기기변경', '번호이동'], // 보여지는 값
      typeId: ['NEW', 'CHANGE', 'MNP'], // api로 보내는 값

      telecomList: ['SKT', 'KT', 'LGU+', '알뜰폰'], // 보여지는 값
      telecomId: ['SKT', 'KT', 'LG', 'MVNO'], // api로 보내는 값

      // s22Color: ['팬텀 화이트', '팬텀 블랙', '그린', '핑크 골드'],
      // s22pColor: ['팬텀 화이트', '팬텀 블랙', '그린', '핑크 골드'],
      // s22uColor: ['팬텀 화이트', '팬텀 블랙', '그린', '버건디'],

      // zFoldColor: ['버건디', '그레이 그린', '팬텀 블랙', '베이지'],
      // zFlipColor: ['보라 퍼플', '그라파이트', '핑크 골드', '블루'],

      color_1: ['핑크', '옐로우', '그린', '블루', '블랙'], // iPhone 15, iPhone 15 Plus
      color_2: ['내추럴 티타늄', '블루 티타늄', '화이트 티타늄', '블랙 티타늄'], // iPhone 15 Pro, iPhone 15 Pro Max

      deviceName_1: ['iPhone 15 128GB', 'iPhone 15 256GB', 'iPhone 15 512GB'],
      deviceName_2: [
        'iPhone 15 Plus 128GB',
        'iPhone 15 Plus 256GB',
        'iPhone 15 Plus 512GB',
      ],
      deviceName_3: [
        'iPhone 15 Pro 128GB',
        'iPhone 15 Pro 256GB',
        'iPhone 15 Pro 512GB',
        'iPhone 15 Pro 1TB',
      ],
      deviceName_4: [
        'iPhone 15 Pro Max 256GB',
        'iPhone 15 Pro Max 512GB',
        'iPhone 15 Pro Max 1TB',
      ],

      deviceColor: [],

      selectedTypeText: '개통유형', // 신규가입 , 번호이동, 기기변경
      selectedTypeOn: false,
      typeVal: '',
      selectedJoinType: '',

      selectedItemText: '예약상품',
      selectedItemOn: false,
      itemVal: '',
      selectedNeedModelName: '',

      selectedColorText: '색상',
      selectedColorOn: false,
      colorVal: '',
      selectedNeedModelColor: '',

      selectedNameText: '고객명',
      selectedNameOn: false,
      selectCustomerName: '',

      selectedBirthText: '생년월일 6자리 (예: 830328)',
      selectedBirthOn: false,
      selectResidentNumber: '',

      selectedPhoneNumText: '연락 받을 번호',
      selectedPhoneNumOn: false,
      selectCustomerMobile: '',

      selectedTelecomText: '이용중인 통신사', // SKT, KT, LGU+, 알뜰폰
      selectedTelecomOn: false,
      telecomVal: '',
      selectedCurrentTelecomId: '',

      isValid: true,
      errorMessage: '',
    };
  },
  methods: {
    ...bookingMapActions([
      bookingTypes.CREATE_BOOKING,
      bookingTypes.FETCH_BOOKING,
      bookingTypes.UPDATE_BOOKING,
    ]),
    async getBookingInfo(id) {
      const bookingData = await this[bookingTypes.FETCH_BOOKING]({ id: id });
      console.log('bbbbb');
      console.log(bookingData);
      // 개통유형 설정
      let found = this.typeId.indexOf(bookingData.joinType);
      this.selectedTypeText = '개통유형 : ' + this.typeList[found];
      this.selectedTypeOn = true;
      this.selectedJoinType = bookingData.joinType; // api 보내는 값 (개통유형)
      this.$refs.typeModal.typeVal = this.typeList[found];

      // 예약상품 설정
      var item = bookingData.needModelName;
      this.itemVal = item;
      this.selectedItemText = '예약상품 : ' + this.itemVal;
      this.selectedItemOn = true;

      // 색상 선택
      if (
        this.deviceName_1.includes(item) ||
        this.deviceName_2.includes(item)
      ) {
        this.deviceColor = this.color_1;
        this.$refs.colorModal.color = this.color_1[0];
      } else if (
        this.deviceName_3.includes(item) ||
        this.deviceName_4.includes(item)
      ) {
        this.deviceColor = this.color_2;
        this.$refs.colorModal.color = this.color_2[0];
      }

      this.colorVal = '';
      this.selectedColorOn = false;
      this.selectedColorText = '색상';
      this.selectedNeedModelName = item; // api 보내는 값 (예약상품)
      this.$refs.itemModal.itemVal = item;

      // 색상 선택
      var color = bookingData.needModelColor;
      this.colorVal = color;
      this.selectedColorText = '색상 : ' + this.colorVal;
      this.selectedColorOn = true;
      this.selectedNeedModelColor = this.colorVal; // api 보내는 값 (색상)
      this.$refs.colorModal.color = color;

      // 고객명
      this.selectedNameOn = true;
      this.selectCustomerName = bookingData.customerName;

      // 생년월일
      this.selectedBirthOn = true;
      this.selectResidentNumber = bookingData.residentNumber;

      // 연락 받을 번호
      this.selectedPhoneNumOn = true;
      this.selectCustomerMobile = bookingData.customerMobile;

      // 이용중인 통신사
      var telecom = bookingData.currentTelecomId;
      let found2 = this.telecomId.indexOf(telecom);

      // console.log('hhhhhhhh');
      // console.log(telecom);
      // console.log(found2);
      // console.log(this.telecomList[found2]);

      this.telecomVal = this.telecomList[found2];
      this.selectedTelecomText = '이용중인 통신사 : ' + this.telecomVal;
      this.selectedTelecomOn = true;
      this.selectedCurrentTelecomId = telecom; // api 보내는 값 (현재 이용중인 통신사)
      this.$refs.telecomModal.telecom = this.telecomVal;
    },
    // new
    showTypeModal() {
      this.$refs.typeModal.isOpen = true;
    },
    closeTypeModal() {
      this.$refs.typeModal.isOpen = false;
    },
    showItemModal() {
      this.$refs.itemModal.isOpen = true;
    },
    closeItemModal() {
      this.$refs.itemModal.isOpen = false;
    },
    showColorModal() {
      // 예약 상품을 먼저 선택해야 한다.
      if (this.selectedItemOn) {
        this.isValid = true;
        this.errorMessage = '';
        this.$refs.colorModal.isOpen = true;
      } else {
        this.isValid = false;
        this.errorMessage = '예약상품을 먼저 선택해 주세요.';
      }
    },
    closeColorModal() {
      this.$refs.colorModal.isOpen = false;
    },
    showTelecomModal() {
      this.$refs.telecomModal.isOpen = true;
    },
    closeTelecomModal() {
      this.$refs.telecomModal.isOpen = false;
    },
    selectType(type) {
      let found = this.typeList.indexOf(type);

      console.log(this.typeId[found]);

      this.typeVal = type;
      this.$refs.typeModal.isOpen = false;
      this.selectedTypeText = '개통유형 : ' + this.typeVal;
      this.selectedTypeOn = true;
      this.selectedJoinType = this.typeId[found]; // api 보내는 값 (개통유형)
    },
    selectItem(item) {
      console.log('item = ' + item);
      this.itemVal = item;
      this.$refs.itemModal.isOpen = false;
      this.selectedItemText = '예약상품 : ' + this.itemVal;
      this.selectedItemOn = true;

      // 색상선택
      if (
        this.deviceName_1.includes(item) ||
        this.deviceName_2.includes(item)
      ) {
        this.deviceColor = this.color_1;
        this.$refs.colorModal.color = this.color_1[0];
      } else if (
        this.deviceName_3.includes(item) ||
        this.deviceName_4.includes(item)
      ) {
        this.deviceColor = this.color_2;
        this.$refs.colorModal.color = this.color_2[0];
      }
      console.log('111111111');
      console.log(this.fColor);

      this.colorVal = '';
      this.selectedColorOn = false;
      this.selectedColorText = '색상';
      this.selectedNeedModelName = item; // api 보내는 값 (예약상품)
    },
    selectColor(color) {
      console.log('color = ' + color);
      this.colorVal = color;
      this.$refs.colorModal.isOpen = false;
      this.selectedColorText = '색상 : ' + this.colorVal;
      this.selectedColorOn = true;
      this.selectedNeedModelColor = this.colorVal; // api 보내는 값 (색상)
    },
    selectTelecom(telecom) {
      let found = this.telecomList.indexOf(telecom);

      console.log(this.telecomId[found]);

      this.telecomVal = telecom;
      this.$refs.telecomModal.isOpen = false;
      this.selectedTelecomText = '이용중인 통신사 : ' + this.telecomVal;
      this.selectedTelecomOn = true;
      this.selectedCurrentTelecomId = this.telecomId[found]; // api 보내는 값 (현재 이용중인 통신사)
    },
    selectNameValueChk() {
      if (this.$refs.selectedName.value.trim() != '') {
        this.selectedNameOn = true;
      } else {
        this.selectedNameOn = false;
        this.$refs.selectedName.value = '';
      }
    },
    selectBirthValueChk() {
      if (this.$refs.selectedBirth.value != '') {
        this.selectedBirthOn = true;
      } else {
        this.selectedBirthOn = false;
      }
    },
    selectPhoneValueChk() {
      if (this.$refs.selectedPhone.value != '') {
        this.selectedPhoneNumOn = true;
      } else {
        this.selectedPhoneNumOn = false;
      }
    },
    // valueChk: function(evt) {
    //   console.log(evt);
    //   evt = evt ? evt : window.event;
    //   var charCode = evt.which ? evt.which : evt.keyCode;
    // },
    // 저장하기
    async saveEstimationAuto() {
      let found = this.selectTelecomList.indexOf(this.selectTelecomName);
      console.log(this.selectTelecomId[found]);

      const data = await this[bookingTypes.CREATE_BOOKING]({
        telecomId: this.selectTelecomId[found],
        joinType: this.selectedJoinType,
        customerName: this.selectCustomerName,
        residentNumber: this.selectResidentNumber,
        customerMobile: this.selectCustomerMobile,
        needModelName: this.selectedNeedModelName,
        needModelColor: this.selectedNeedModelColor,
        currentTelecomId: this.selectedCurrentTelecomId,
      });

      console.log(data);
      this.$router.go(-1);
      //this.$refs.attachmentModal.isOpen = true;
    },

    async modifyEstimationAuto() {
      let found = this.selectTelecomList.indexOf(this.selectTelecomName);
      console.log(this.selectTelecomId[found]);

      const data = await this[bookingTypes.UPDATE_BOOKING]({
        id: this.id,
        telecomId: this.selectTelecomId[found],
        joinType: this.selectedJoinType,
        customerName: this.selectCustomerName,
        residentNumber: this.selectResidentNumber,
        customerMobile: this.selectCustomerMobile,
        needModelName: this.selectedNeedModelName,
        needModelColor: this.selectedNeedModelColor,
        currentTelecomId: this.selectedCurrentTelecomId,
      });

      // console.log(data);
      this.$router.go(-1);
      // this.$router.push({
      //   name: 'chat.room',
      //   params: {
      //     uuid: this.uuid,
      //   },
      // });
      //this.$refs.attachmentModal.isOpen = true;
    },
  },
};
</script>
